export { default as SweepBulkActionCustomData } from './store/schema/SweepBulkActionCustomData';
export { default as sweepStore } from './store/store';
export { default as SweepOptionType } from './store/schema/SweepOptionType';
export { default as SweepRequestStatus } from './store/schema/SweepRequestStatus';
export { default as setSweepOptionType } from './actions/setSweepOptionType';
export { default as setSweepRequestStatus } from './actions/setSweepRequestStatus';
export { default as showHideSweepDialog } from './actions/showHideSweepDialog';

import { LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "SweepStore" */ './lazyIndex'));

export let lazyOnSweepMoveToFolderClicked = new LazyImport(
    lazyModule,
    m => m.onSweepMoveToFolderClicked
);

export let lazySetSweepDestinationFolderId = new LazyImport(
    lazyModule,
    m => m.setSweepDestinationFolderId
);
